import { KngChartsState } from './definitions';
export class KngChartsFactory 
{
	public static buildState(): KngChartsState 
	{
		return {
			chart: {
				id: '',
				widgetType: '',
				cta: { label: '' },
				title: '',
				summaryUnits: [],
				chart: {
					type: 'pie',
					data: { labels: [], datasets: [] },
					options: {
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							tooltip: {
								backgroundColor: '#FFFFFF',
								borderColor: '#C4C4C4',
								titleColor: '#000000',
								bodyColor: '#000000',
								cornerRadius: 0,
								padding: 10,
								borderWidth: 1,
								displayColors: false
							},
							legend: { display: true }
						},
						elements: { line: { tension: 1 } },
						scales: {
							x: {
								offset: false,
								suggestedMin: 0,
								suggestedMax: 500,
								grid: {
									color: '#F7F7F8',
									display: true,
									drawBorder: true
								},
								ticks: {
									stepSize: 100,
									display: true
								}
							},
							y: {
								offset: false,
								suggestedMin: 0,
								suggestedMax: 500,
								grid: {
									color: '#F7F7F8',
									display: true,
									drawBorder: true
								},
								ticks: {
									stepSize: 100,
									display: true
								}
							}
						}
					}
				}
			}
		};
	}

	public static buildBarState(): KngChartsState 
	{
		return {
			chart: {
				id: '83e94091-9894-4a74-b995-6e76cbdd3ba4',
				widgetType: 'chart-card',
				cta: {
					label: 'View More'
				},
				summaryUnits: [],
				title: 'Number of Units',
				chart: {
					type: 'bar',
					data: {
						datasets: [
							{
								backgroundColor: '#1887F2',
								barThickness: 8,
								borderColor: '#1887F2',
								data: [ 510, 530, 1134, 1400 ],
								hoverBackgroundColor: '#1887F2',
								label: 'Units per Location',
								pointBackgroundColor: '#1887F2',
								pointHoverBorderColor: '#1887F2'
							}
						],
						labels: [ 'Location A', 'Location B', 'Location C', 'Location D' ]
					},
					options: {
						elements: { line: { tension: 1 } },
						maintainAspectRatio: false,
						plugins: this.getPlugin(),
						responsive: true,
						scales: {
							x: {
								grid: {
									color: '#F7F7F8',
									display: false,
									drawBorder: false
								},
								offset: true
							},
							y: {
								grid: {
									color: '#F7F7F8',
									drawBorder: false
								},
								suggestedMax: 2000,
								suggestedMin: 0,
								ticks: { stepSize: 500 }
							}
						}
					}
				}
			}
		};
	}

	public static buildBarSummaryState(): KngChartsState 
	{
		return {
			chart: {

				id: '83e94091-9894-4a74-b995-6e76cbdd3ba4',
				widgetType: 'chart-card',
				cta: { label: 'View More' },
				title: 'Average Age of Equipment',
				summaryUnits: [
					{ label: '3', description: 'years (Average age)' }
				],
				chart: {
					type: 'bar',
					data: {
						datasets: [{
							backgroundColor: '#1887F2',
							barThickness: 8,
							borderColor: '#1887F2',
							data: [ 470, 1200, 700, 1400 ],
							label: 'Units',
							hoverBackgroundColor: '#1887F2',
							pointBackgroundColor: '#1887F2',
							pointHoverBorderColor: '#1887F2'
						}],
						labels: [ '<2 years', '3-5 years', '6-10 years', '>10 years' ]
					},
					options: {
						maintainAspectRatio: false,
						plugins: this.getPlugin(),
						responsive: true,
						scales: {
							x: {
								grid: {
									color: '#F7F7F8',
									display: false,
									drawBorder: false
								},
								offset: true
							},
							y: {
								grid: {
									color: '#F7F7F8',
									drawBorder: false
								},
								suggestedMax: 2000,
								suggestedMin: 0,
								ticks: { stepSize: 500 }
							}
						}
					}
				}
			}
		};
	}

	public static buildPieState(): KngChartsState 
	{
		return {
			chart: {

				id: '83e94091-9894-4a74-b995-6e76cbdd3ba4',
				widgetType: 'chart-card',
				cta: { label: 'View More' },
				summaryUnits: [
					{ label: '0', description: '' }
				],
				title: 'Leased Equipment',
				chart: {
					type: 'pie',
					data: {
						datasets: [{
							backgroundColor: [ '#CEE7FF', '#FFAB7A' ],
							borderColor: [ '#CEE7FF', '#FFAB7A' ],
							hoverBackgroundColor: [ '#CEE7FF', '#FFAB7A' ],
							hoverBorderColor: [ '#FFFFFF', '#FFFFFF' ],
							data: [ 1567, 700 ],
							label: 'Units'
						}],
						labels: [ 'TICF Leased', 'Other' ]
					},
					options: {
						maintainAspectRatio: false,
						plugins: {
							legend: {
								position: 'right',
								align: 'center',
								maxWidth: 200,
								labels: {
									boxHeight: 8,
									boxWidth: 38,
									font: { size: 12 }
								}
							},
							tooltip: this.getTooltip()
						},
						responsive: true,
						scales: this.getScales()
					}
				}
			}
		};
	}

	public static buildPieSummaryState(): KngChartsState 
	{
		return {
			chart: {

				id: '83e94091-9894-4a74-b995-6e76cbdd3ba4',
				widgetType: 'chart-card',
				cta: { label: 'View More' },
				title: 'New Equipment Orders',
				summaryUnits: [
					{ label: '3', description: 'open orders' }
				],
				chart: {
					type: 'pie',
					data: {
						datasets: [{
							data: [ 1134, 554 ],
							label: 'Units',
							backgroundColor: [ '#CEE7FF', '#FFAB7A' ],
							borderColor: [ '#CEE7FF', '#FFAB7A' ],
							hoverBackgroundColor: [ '#CEE7FF', '#FFAB7A' ],
							hoverBorderColor: [ '#FFFFFF', '#FFFFFF' ]
						}],
						labels: []
					},
					options: {
						maintainAspectRatio: false,
						plugins: {
							legend: {
								position: 'right',
								align: 'center',
								maxWidth: 200,
								labels: {
									boxHeight: 8,
									boxWidth: 38,
									font: { size: 12 }
								}
							},
							tooltip: this.getTooltip()
						},
						responsive: true,
						scales: this.getScales()
					}
				}
			}
		};
	}
	public static getPlugin() 
	{
		return {
			legend: { display: false },
			tooltip: this.getTooltip()
		};
	}
	public static getTooltip()
	{
		return {
			backgroundColor: '#FFFFFF',
			borderColor: '#F26A21',
			titleColor: '#616365',
			bodyColor: '#616365',
			cornerRadius: 0,
			padding: 10,
			borderWidth: 1,
			caretSize: 0,
			displayColors: false
		};
	}
	public static getScales() 
	{
		return {
			x: {
				grid: {
					color: '#F7F7F8',
					display: false,
					drawBorder: false
				},
				offset: true,
				ticks: { display: false }
			},
			y: {
				grid: {
					color: '#F7F7F8',
					drawBorder: false
				},
				suggestedMax: 2000,
				suggestedMin: 0,
				ticks: {
					display: false,
					stepSize: 500
				}
			}
		};
	}
}

